import React from "react";
import { useNavigate } from "react-router-dom";
import { Stack, Box, Typography, Button, Card, CardContent } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

/**
 * Stripe Checkout success landing. Webhook handler on the server promotes
 * the tenant's plan/status; this page is just confirmation for the user.
 */
export const BillingSuccessPage = () => {
  const navigate = useNavigate();
  return (
    <Stack
      spacing={3}
      sx={{
        p: { xs: 2, md: 6 },
        backgroundColor: "#f8fafc",
        height: "calc(100vh - 80px)",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card variant="outlined" sx={{ borderRadius: 3, maxWidth: 520 }}>
        <CardContent sx={{ p: 4, textAlign: "center" }}>
          <CheckCircleIcon sx={{ fontSize: 64, color: "#16a34a" }} />
          <Typography variant="h4" sx={{ fontWeight: 700, mt: 2, mb: 1 }}>
            You're all set.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Your subscription is active. It may take a few seconds for the new plan to reflect across the app — refresh if you don't see it yet.
          </Typography>
          <Box sx={{ display: "flex", gap: 1, justifyContent: "center", flexWrap: "wrap" }}>
            <Button
              variant="contained"
              sx={{ backgroundColor: "#1F4E78" }}
              onClick={() => navigate("/billing")}
            >
              Manage subscription
            </Button>
            <Button variant="outlined" onClick={() => navigate("/")}>
              Back to dashboard
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Stack>
  );
};

export default BillingSuccessPage;
